export const environment = {
  production: true,
  version: 'eafee2584d'
};
